import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableSortLabel,
  Pagination,
  Typography,
} from "@mui/material";

import { displayDateFun } from "app/utils/constants/functions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Div from "@jumbo/shared/Div";
import UserLogModal from "./UserLogModal";
import { getUserLogList } from "app/services/apis/ListApi/userLogList";

export default function UserLogTable() {
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [logList, setLogList] = useState([]);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(1);

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };

  // const sortedData = logList.result?.sort((a, b) => {
  //   const aValue = a[orderBy];
  //   const bValue = b[orderBy];
  //   if (order === "desc") {
  //     return aValue < bValue ? -1 : 1;
  //   } else {
  //     return bValue < aValue ? -1 : 1;
  //   }
  // });

  useEffect(async () => {
    setLogList(await getUserLogList());
  }, []);

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    const data = await getUserLogList(newPage);

    if (data) {
      setLogList(data);
    } else {
      setLogList([{}]);
    }
  };

  const handleInfoIconClick = (rowData) => {
    setSelectedRowData(rowData);
    setInfoModalOpen(true);
  };

  return (
    <>
      <Div sx={{ mt: -4, mb: 4 }}>
        <Typography variant="h1">User Log</Typography>
      </Div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Employee ID
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Employee Name
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Updated User ID
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Action
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Date
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "40px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                View
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logList?.result?.map((row, i) => (
              <TableRow key={i}>
                <TableCell
                  sx={{
                    textAlign: "left",
                    pl: 2,
                  }}
                >
                  {row.user.employee_id}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {`${row.user.first_name} ${row.user.last_name}`}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    pl: 2,
                  }}
                >
                  {row.updated_user_employee_id}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    pl: 2,
                  }}
                >
                  {row.user_action}
                </TableCell>

                <TableCell sx={{ textAlign: "left" }}>
                  {row.user_action == "CREATE"
                    ? row.user_create_date == null
                      ? "N/A"
                      : displayDateFun(row.user_logs_create_date)
                    : row.user_update_date == null
                    ? "N/A"
                    : displayDateFun(row.user_update_date)}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                    maxWidth: "100px",
                    pl: 3,
                  }}
                >
                  <VisibilityIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleInfoIconClick(row)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Pagination
          count={logList?.totalPages || 1}
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
          }}
        />
        <UserLogModal
          open={isInfoModalOpen}
          onClose={() => setInfoModalOpen(false)}
          rowData={selectedRowData}
        />
      </TableContainer>
    </>
  );
}
